import axios from 'axios';

export const getTheme = () => {
  return axios
    .get('/static/theme/config/theme.json')
    .then(res => ({ theme: res.data }));
};
